import { type CarouselData } from '@/features/cms/components/CMS/types'
import { CMSErrorHandler } from '@/features/cms/components/CMS/CMSErrorHandler'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'
import { MobileCarousel } from '@/features/cms/components/CMS/components/Carousel/MobileCarousel'
import { DesktopCarousel } from '@/features/cms/components/CMS/components/Carousel/DesktopCarousel'
import { useMemo } from 'react'
import { truncateRichText } from '@/features/cms/components/CMS/RichTextRenderer'
import { Box } from '@shipt/design-system-layouts'

const DELAY_BETWEEN_TRANSITIONS = 7_500

/**
 * This component corresponds to the `carousel` content type in the CMS.
 *
 * - **Staging** - https://cms-staging.shipt.com/content-type/pool/carousel
 * - **Production** - https://cms.shipt.com/content-type/pool/carousel
 */
export const Carousel = ({
  content_type_id,
  id,
  data: { carousel_sections, image_placement, disable_auto_play = false },
}: CarouselData) => {
  const sections = useMemo(() => {
    return carousel_sections.map((section) => ({
      ...section,
      data: {
        ...section.data,
        subheading_rich_text: {
          elements: truncateRichText(
            section.data.subheading_rich_text?.elements ?? [],
            section.data.rich_text_characters_limit,
          ),
        },
      },
    }))
  }, [carousel_sections])
  try {
    return (
      <GridLayoutContainer {...getCMSWrapperProps({ content_type_id, id })}>
        <Box display={{ base: 'block', md: 'none' }}>
          <MobileCarousel
            disableAutoPlay={disable_auto_play}
            sections={sections}
            delay={DELAY_BETWEEN_TRANSITIONS}
          />
        </Box>
        <Box display={{ base: 'none', md: 'block' }}>
          <DesktopCarousel
            disableAutoPlay={disable_auto_play}
            sections={sections}
            delay={DELAY_BETWEEN_TRANSITIONS}
            imagePlacement={image_placement}
          />
        </Box>
      </GridLayoutContainer>
    )
  } catch (error) {
    return <CMSErrorHandler error={error} contentTypeId={content_type_id} id={id} />
  }
}
